export const MIN_API_SLOTS = 10;
export const API_SLOTS_STEP = 10;

export const getApiSlotsValidation = (numApiSlots: number) => {
  const hasMinSlotsError = !numApiSlots || numApiSlots < MIN_API_SLOTS;
  const isInvalidStep = !hasMinSlotsError && numApiSlots % API_SLOTS_STEP !== 0;
  return { hasMinSlotsError, isInvalidStep };
};

export const getIsApiSlotsPriceRowVisible = ({
  numApiSlots,
  additionalSlotPrice,
  isStandaloneApiSlots,
}: {
  numApiSlots: number | null | undefined;
  additionalSlotPrice: Record<number, number> | null | undefined;
  isStandaloneApiSlots: boolean | null | undefined;
}) => {
  const { hasMinSlotsError, isInvalidStep } = getApiSlotsValidation(
    numApiSlots ?? 0
  );
  return (
    (numApiSlots ?? 0) > 0 &&
    !hasMinSlotsError &&
    !isInvalidStep &&
    (!!additionalSlotPrice || !!isStandaloneApiSlots)
  );
};
